import ColorButton from './color-button'

export default ColorButton
